export const route = {
	/** Family dashboard (post-login landing for parents) */
	dashboard: '',
	/** Alias kept for older links that meant “app home” = dashboard */
	home: '/',
	/** Catalog / order menu (former Home page) */
	menu: 'menu',
	login: 'login',
	orders: 'orders',
	ordersDetail: 'orders/detail',
	account: 'account',
	accountPassword: 'account/update-password',
	accountTopUps: 'account/top-ups',
	cart: 'cart',
	cartItem: 'cart/item',
	item: 'item',
	notification: 'notification',
	accountTopUp: 'account/top-up',
};

/** Path helpers — prefer these over hard-coded '/' for “menu” vs “dashboard”. */
export const pathDashboard = '/';
export const pathMenu = `/${route.menu}`;
export const pathOrders = `/${route.orders}`;
